import { ref } from 'vue'

// Estado global de notificaciones
const notifications = ref([])

export function useNotifications() {
  
  const showNotification = (type, title, message, duration = 4000, options = {}) => {
    const id = Date.now() + Math.random() // Más único
    const notification = {
      id,
      type, // 'success', 'error', 'warning', 'info'
      title,
      message,
      timestamp: new Date(),
      options: {
        position: 'top-right', // 'top-right', 'top-left', 'top-center', 'bottom-right', 'bottom-left', 'bottom-center'
        compact: false, // Para notificaciones más compactas
        ...options
      }
    }
    
    notifications.value.push(notification)
    
    // Auto-remover después del tiempo especificado
    setTimeout(() => {
      removeNotification(id)
    }, duration)
    
    return id
  }

  const removeNotification = (id) => {
    const index = notifications.value.findIndex(n => n.id === id)
    if (index > -1) {
      notifications.value.splice(index, 1)
    }
  }

  const clearAllNotifications = () => {
    notifications.value = []
  }

  // Métodos de conveniencia
  const showSuccess = (title, message, duration, options) => {
    return showNotification('success', title, message, duration, options)
  }

  const showError = (title, message, duration, options) => {
    return showNotification('error', title, message, duration, options)
  }

  const showWarning = (title, message, duration, options) => {
    return showNotification('warning', title, message, duration, options)
  }

  const showInfo = (title, message, duration, options) => {
    return showNotification('info', title, message, duration, options)
  }

  return {
    notifications: notifications.value,
    showNotification,
    removeNotification,
    clearAllNotifications,
    showSuccess,
    showError,
    showWarning,
    showInfo
  }
}